<template>
  <div class="personal-data">
    <div class="list">
      <div class="item acea-row row-between-wrapper">
        <div class="name">类型</div>
        <div class="input">
          <select v-model="userInfo.paper_type">
            <option value="1">请选择类型</option>
            <option
              value="3"
              :selected="userInfo.paper_type == 3 ? true : false"
              >潜店/总监</option
            >
            <option
              value="2"
              :selected="userInfo.paper_type == 2 ? true : false"
              >教练</option
            >
          </select>
        </div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>潜店/教练号</div>
        <div class="input">
          <input type="text" v-model="userInfo.paper_id" />
        </div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>联系方式</div>
        <div class="input">
          <input type="text" v-model="userInfo.contact" />
        </div>
      </div>
      <div class="wrapper" style="height: 3rem;">
        <div class="title">上传资质(教练证件照/营业执照/潜店照片):</div>
        <!-- <div class="wrapList"> -->
        <!-- <div class="picTxt acea-row row-between-wrapper"> -->
        <div style="width: 33%;float: left;">
        <VueCoreImageUpload
          class="btn btn-primary"
          :crop="false"
          compress="80"
          @imageuploaded="imageuploaded"
          :headers="headers"
          :max-file-size="5242880"
          :credentials="false"
          inputAccept="image/*"
          inputOfFile="file"
          :url="url"
          ref="upImg"
        >
          <div class="pictrue" style="text-align:center;">
            <img
              v-if="userInfo.paper_img"
              :src="userInfo.paper_img"
              style="width: 65%;"
            />
            <img
              v-else
              src="@assets/images/uploadTip.png"
              style="width: 65%;"
            />
          </div>
        </VueCoreImageUpload>
        </div>
        <div style="width: 33%;float: left;">
        <VueCoreImageUpload
          class="btn btn-primary"
          :crop="false"
          compress="80"
          @imageuploaded="imageuploaded1"
          :headers="headers"
          :max-file-size="5242880"
          :credentials="false"
          inputAccept="image/*"
          inputOfFile="file"
          :url="url"
          ref="upImg"
        >
          <div class="pictrue" style="text-align:center;">
            <img
              v-if="userInfo.paper_img1"
              :src="userInfo.paper_img1"
              style="width: 65%;"
            />
            <img
              v-else
              src="@assets/images/uploadTip.png"
              style="width: 65%;"
            />
          </div>
        </VueCoreImageUpload>
        </div>
        <div style="width: 33%;float: left;">
        <VueCoreImageUpload
          class="btn btn-primary"
          :crop="false"
          compress="80"
          @imageuploaded="imageuploaded2"
          :headers="headers"
          :max-file-size="5242880"
          :credentials="false"
          inputAccept="image/*"
          inputOfFile="file"
          :url="url"
          ref="upImg"
        >
          <div class="pictrue" style="text-align:center;">
            <img
              v-if="userInfo.paper_img2"
              :src="userInfo.paper_img2"
              style="width: 65%;"
            />
            <img
              v-else
              src="@assets/images/uploadTip.png"
              style="width: 65%;"
            />
          </div>
        </VueCoreImageUpload>
        </div>
        <!-- </div> -->
        <!-- </div> -->
      </div>
    </div>
    <div class="modifyBnt bg-color-red" @click="submit">保存修改</div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { trim, VUE_APP_API_URL, isWeixin } from "@utils";
import VueCoreImageUpload from "vue-core-image-upload";
import { postAgentEdit } from "@api/user";
// import { postAgentEdit, getUser } from "@api/user";
// import store from "@/store";

export default {
  name: "UserAgent",
  components: {
    VueCoreImageUpload
  },
  data: function() {
    return {
      url: `${VUE_APP_API_URL}/upload/image`,
      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token
      },
      paper_img: "",
      paper_img1: "",
      paper_img2: "",
      isWeixin: false,
      currentAccounts: 0,
      switchUserInfo: [],
      userIndex: 0
    };
  },
  watch: {
    $route(n) {
      if (n.name === "PersonalData") this.$store.dispatch("USERINFO", true);
    }
  },
  computed: mapGetters(["userInfo"]),
  mounted: function() {
    this.paper_img = this.userInfo.paper_img;
    this.paper_img1 = this.userInfo.paper_img1;
    this.paper_img2 = this.userInfo.paper_img2;
    this.isWeixin = isWeixin();
  },
  methods: {
    imageuploaded(res) {
      if (res.status !== 200)
        return this.$dialog.error(res.msg || "上传图片失败");
      // if (this.switchUserInfo[this.userIndex] === undefined) return;
      // console.log(this);
      this.$set(this.userInfo, "paper_img", res.data.url);
    },
    imageuploaded1(res) {
      if (res.status !== 200)
        return this.$dialog.error(res.msg || "上传图片失败");
      // if (this.switchUserInfo[this.userIndex] === undefined) return;
      // console.log(this);
      this.$set(this.userInfo, "paper_img1", res.data.url);
    },
    imageuploaded2(res) {
      if (res.status !== 200)
        return this.$dialog.error(res.msg || "上传图片失败");
      // if (this.switchUserInfo[this.userIndex] === undefined) return;
      // console.log(this);
      this.$set(this.userInfo, "paper_img2", res.data.url);
    },

    submit: function() {
      postAgentEdit({
        paper_type: this.userInfo.paper_type,
        paper_id: trim(this.userInfo.paper_id),
        contact: trim(this.userInfo.contact),
        paper_img: this.userInfo.paper_img,
        paper_img1: this.userInfo.paper_img1,
        paper_img2: this.userInfo.paper_img2
      }).then(
        res => {
          this.$store.dispatch("USERINFO", true);
          this.$dialog.success(res.msg);
          this.$router.go(-1);
        },
        error => {
          this.$dialog.error(error.msg);
        }
      );
    }
  }
};
</script>
